import { VCombobox } from 'vuetify/lib/components/VCombobox';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCombobox,_vm._b({attrs:{"items":_vm.actions,"label":_vm.$t('Action'),"outlined":"","hide-details":"auto"},model:{value:(_vm.action),callback:function ($$v) {_vm.action=$$v},expression:"action"}},'v-combobox',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }